import script from "./SignupForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignupForm.vue?vue&type=script&setup=true&lang=ts"

import "./SignupForm.vue?vue&type=style&index=0&id=0a9b9a85&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a9b9a85"]])

export default __exports__